import { render, staticRenderFns } from "./BackIcon.vue?vue&type=template&id=d718aaac"
import script from "./BackIcon.vue?vue&type=script&lang=ts"
export * from "./BackIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports